import(/* webpackMode: "eager" */ "/app/apps/student/src/components/loading/frog.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
